import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  skip(event) {
    event.preventDefault()
    event.stopPropagation()
    this.performAction(event.currentTarget)
  }

  unskip(event) {
    event.preventDefault()
    event.stopPropagation()
    this.performAction(event.currentTarget)
  }

  skipAll(event) {
    event.preventDefault()
    this.performAction(event.currentTarget)
  }

  unskipAll(event) {
    event.preventDefault()
    this.performAction(event.currentTarget)
  }

  performAction(link) {
    const url = link.dataset.url
    const scrollPosition = window.scrollY

    fetch(url, {
      method: 'GET',
      headers: {
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
        'Accept': 'application/json'
      }
    })
    .then(response => {
      window.location.reload()
      // Restore scroll position after reload
      window.addEventListener('load', () => {
        window.scrollTo(0, scrollPosition)
      }, { once: true })
    })
    .catch(error => {
      console.error('Error performing budget action:', error)
    })
  }
}

